export interface GenabilityTariffPropertyChoice {
  value: string;
  displayValue: string;   // Typically always the same as value, so somewhat redundant.
}

export const BOOLEAN_CHOICES: Array<GenabilityTariffPropertyChoice> = [
  { value: 'true', displayValue: 'true'},
  { value: 'false', displayValue: 'false'}
];
